import OrdensServicoService from "@/services/Registros/OrdensServicoService"
import OrdemServicoItem from "@/entities/OrdemServicoItem/OrdemServicoItem"

// Usecases
import { UseCaseSelo } from '@/entities/Selo/UseCaseSelo.js'

export class useCaseOrdemServicoItem {
  constructor (ordemServicoItem) {
    this.ordemServicoItem = ordemServicoItem || null
  }

  async create (ordemServico) {
    try {
      const { custa, quantidade, averbacao, seloStatus,  flag_cancelado, descricao, valor, zerarCusta } = this.ordemServicoItem
      const { matricula_pedido_crc, ordem_servico_id } = ordemServico
  
      const payload = {
        custa_id: custa.custa_id,
        ordem_servico_id,
        valor,
        quantidade,
        averbacao,
        descricao,
        matricula_pedido_crc,
        seloStatus,
        flag_cancelado,
        zerarCusta
      }
  
      this.ordemServicoItem = await new OrdensServicoService.storeOsItem(payload)
      return this.ordemServicoItem
    } catch (error) {
      const message = error.message
      console.log(message)
    }
    if (!ordemServico?.ordem_servico_id) {
      throw ('Id da Ordem de Serviço não foi informado')
    }
    if (!this.ordemServicoItem) {
      throw ('As informações do Item Os devem ser passadas')
    }
    

  }

  async update () {
    try { 
        for (const seloItemOs of this.ordemServicoItem?.seloItemOs) {
          const { selo } = seloItemOs
          // evita que se tente cancelar um selo já cancelado
          if ((selo.cancelado_tj || selo.excluido_tj) && !selo.retificarSelo) continue

          if (selo.excluirSelo && !selo.retificarSelo) await new UseCaseSelo(selo).excluir()   

          if (selo.cancelarSelo && !selo.retificarSelo) await new UseCaseSelo(selo).cancelar()

          if (selo.retificarSelo) await new UseCaseSelo(selo).retificar()     
        }      
      
      const payload = {
        ...this.ordemServicoItem,
        valor: this.ordemServicoItem.valor
      }

      const item = await OrdensServicoService.updateOsItem(payload, this.ordemServicoItem.ordem_servico_item_id)
      return item

    } catch (error) {
      const message = error.message
      throw Error(message)
    }
  }
  async delete (id) {
    if (!id && !this.ordemServicoItem) {
      throw ('Id do Item da Ordem de Serviço a ser excluido não foi informado')
    }
    await OrdensServicoService.destroyOsItem(id || this.ordemServicoItem.ordem_servico_item_id)
    return 'Item da Ordem de Serviço Excluido com sucesso'
  }
}